import TabPage from "./../../factories/tab-page";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
class ConfigurationItemSystemTab {
    Bao = Bao;
    Loading = ko.observable<boolean>(false);
    MemoryPhysical = ko.observable();
    MemoryPagefile = ko.observable();
    MemoryVirtual = ko.observable();
    ServicePack = ko.observable();
    ProcessorCount = ko.observable();
    ProcessorClockSpeed = ko.observable();
    ProcessorId = ko.observable();
    ProcessorName = ko.observable();
    OperatingSystemId = ko.observable();
    OperatingSystemName = ko.observable();
    constructor(public TabPage: TabPage, public Parent) {
        this.TabPage.DirtyFlag.subscribe((isDirty) => {
            if (isDirty) {
                this.Parent.TabPage.DirtyFlag(true);
            }
        });
    }
    CompleteCheck() {
        var def = $.Deferred();
        def.resolve(true);
        return def.promise();
    }
    Refresh() {
        this.Loading(true);
        this.TabPage.IsLoading(true);
        return Bao.post("ConfigurationItemSystemTab/Get", JSON.stringify({
            id: this.Parent.ConfigurationItemId(),
        }), (result) => {
            if (result != null) {
                ko.map.fromJS(result, this, this.TabPage.DirtyFlag);
            }
            this.Loading(false);
            this.TabPage.IsLoading(false);
        });
    }
    Save(saveTime) {
        this.Loading(true);
        this.TabPage.IsLoading(true);
        return Bao.post("ConfigurationItemSystemTab/Save", JSON.stringify({
            saveTime: saveTime,
            model: ko.map.toJS(this)
        }), (result) => {
            this.Loading(false);
            this.TabPage.DirtyFlag(false);
            this.TabPage.IsLoading(false);
        });
    }
    init() {
    }
    loaded() {
        return this.Refresh();
    }
    ;
}
export default ConfigurationItemSystemTab;